"use client";

import { useMemo } from "react";
import { Shortcut } from "../hooks/keyboard-shortcuts-manager-v2";
import { useKeyboardShortcuts } from "../hooks/use-keyboard-shortcuts";
import { useStableId } from "../hooks/use-stable-id";

export function KeyboardShortcuts({
	shortcuts,
	layerName,
	groupId,
	unique = true,
}: {
	shortcuts: Shortcut[];
	layerName: string;
	groupId?: string;
	unique?: boolean;
}): null {
	const id = unique ? useStableId() : undefined;
	const combinedId = useMemo(() => {
		const entries = [layerName];

		if (groupId) {
			entries.push(groupId);
		}

		if (id && !groupId) {
			entries.push(id);
		}

		return entries.join("-");
	}, [groupId, layerName, unique]);

	useKeyboardShortcuts(shortcuts, combinedId, [shortcuts, id]);

	return null;
}
